import React from 'react';

// Single source of truth for "how good/bad is this number" styling across every
// Evidence grid (SLA Metrics, Segments, Transitions, etc). Renders a small pill
// instead of flooding the whole cell with a saturated background colour, so a
// table full of metrics stays scannable instead of looking like a heat map.

export const SEVERITY_COLORS = {
  good: { bg: '#E3FCEF', fg: '#006644' },
  watch: { bg: '#FFF0B3', fg: '#974F0C' },
  high: { bg: '#FFEBE6', fg: '#AE2A19' },
  neutral: { bg: '#F4F5F7', fg: '#42526E' },
};

// Generic threshold helper. By default higher = worse (breach rates, rework
// rates). Pass invert:true for metrics where lower = worse (flow efficiency).
export function tierForRate(value, { watch = 0.15, high = 0.25, invert = false } = {}) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 'neutral';
  if (invert) {
    if (n < watch) return 'high';
    if (n < high) return 'watch';
    return 'good';
  }
  if (n >= high) return 'high';
  if (n >= watch) return 'watch';
  return 'good';
}

export function MetricBadge({ label, tier = 'neutral' }) {
  const colors = SEVERITY_COLORS[tier] || SEVERITY_COLORS.neutral;
  return (
    <span
      className="metric-badge"
      style={{ background: colors.bg, color: colors.fg }}
    >
      {label}
    </span>
  );
}

// Convenience factory for an ag-grid cellRenderer: pass a value formatter and
// a function that turns the raw value into a tier ('good' | 'watch' | 'high' | 'neutral').
export function badgeCellRenderer(formatValue, getTier) {
  return function BadgeCell(params) {
    if (params.value === null || params.value === undefined || params.value === '') return '—';
    const tier = getTier(params.value, params.data);
    return <MetricBadge label={formatValue(params.value, params.data)} tier={tier} />;
  };
}

export default MetricBadge;
